<template>
    <section class="vraag  w100 clearfix" :class="[error ? 'error-recaptcha' : '']">
        <vue-recaptcha ref="recaptcha" :sitekey="sitekey" @loaded="onLoaded"></vue-recaptcha>
        <div class="error-tooltip"><span>{{ error }}</span></div>
    </section>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';
export default {
    props: {
        error: String,
    },
    components: {
        VueRecaptcha
    },
    computed: {
        sitekey() {

            return process.env.VUE_APP_RECAPTCHA;
        },
    },
    methods: {
        onLoaded() {
            this.$refs.recaptcha.reset();
        }
    }
}
</script>